module.exports = new __parcel__URL__("janeckova_x2.7518544e.webp").toString();